import getDepositStatsQuery from "../../../../graphQl/queries/getDepositsStats";

export const getDepositsStats = async ( {dispatch, rootGetters, rootState: { app } }, { from, to }) => {
    const organizationId = rootGetters['app/getSelectedOrganization'].id;

    let stats;

    try {
        stats = await dispatch('app/request', {
            type: 'query',
            gql: getDepositStatsQuery,
            variables: {
                organizationId,
                from,
                to
            },
        }, {root: true});
    } catch (error) {
        return error;

    }

    if (stats.message) {
        throw stats.message;
    }

    if (stats.errors) {
        throw stats.errors;
    }
    const {
        data: {
            depositsStats
        },
    } = stats;

    const fiats = ['EUR', 'RUB', 'INR']
    const currencies = app.currencies

    depositsStats.forEach(transaction => {
        const currencyObj = currencies.find(({ id }) => id === transaction.currencyId)
        const { usdRate } = currencyObj

        transaction['amountUSD'] = transaction.amount * usdRate

        fiats.forEach((abbr) => {
            let fiatCurrObj = currencies.find(({ currency }) => currency === abbr)
            switch (abbr) {
                case 'EUR':
                    transaction['amountEUR'] = transaction['amountUSD'] / fiatCurrObj['usdRate']
                    break
                case 'RUB':
                    transaction['amountRUB'] = transaction['amountUSD'] / fiatCurrObj['usdRate']
                    break
                case 'INR':
                    transaction['amountINR'] = transaction['amountUSD'] / fiatCurrObj['usdRate']
                    break

            }
        })
    })

    // make summary calc
    return depositsStats.reduce((acc, transaction) => {
        const txIndex = acc.findIndex(({ currencyId, networkId }) => transaction.currencyId === currencyId  && transaction.networkId === networkId)
         if (txIndex < 0) {
             acc.push(transaction)
         } else {
             acc[txIndex].amount = Number(acc[txIndex].amount) + Number(transaction.amount)
             acc[txIndex].amountUSD = Number(acc[txIndex].amountUSD) + Number(transaction.amountUSD)
             acc[txIndex].amountEUR = Number(acc[txIndex].amountEUR) + Number(transaction.amountEUR)
             acc[txIndex].amountRUB = Number(acc[txIndex].amountRUB) + Number(transaction.amountRUB)
             acc[txIndex].amountINR = Number(acc[txIndex].amountINR) + Number(transaction.amountINR)
         }
        return acc
    }, []).sort((a, b) => b.amountUSD - a.amountUSD)
};
